import { useContext, useEffect, useState } from "react";
import React from "react";
import Button from "antd/lib/button";
import EditOutlined from "@ant-design/icons/EditOutlined";
import { FormContext } from "../../../contexts/form/index.context";
import Modal from "antd/lib/modal";
import { ModalComponentProps } from "./types";
import { ModalContext } from "../../../contexts/modal/index.context";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import { SessionContext } from "../../../contexts/session/index.context";
import { TableContext } from "../../../contexts/table/index.context";
import { DatepickerContext } from "../../../contexts/datepicker/index.context";
import { TranslationContext } from "../../../contexts/translation/index.context";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";
import { useSignModal } from "../../../contexts/sign-modal/index.context";
// import checkIsAdmin from '../../../helpers/checkIsAdmin';
import message from "antd/lib/message";
import checkBefore from "../../../helpers/selectionOfActions";
import { request } from "../../../services";
//UI
import Tooltip from "antd/lib/tooltip";
//Icons

// Компонент модалки глобальний керує відкриттям/закриттям

export default function ModalComponent(props: ModalComponentProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const context = useContext(ModalContext);
  const { setOpenModalFlag, setRefresh } = useContext(ModalContext);
  const contextDatePicker = useContext(DatepickerContext);
  const { openSignModal, closeSignModal } = useSignModal();
  const { form } = useContext(FormContext);
  const { intl } = useContext(TranslationContext);
  const { sessionData, setSessionData } = useContext(SessionContext);
  const { contextTableData, setContextTableData } = useContext(TableContext);
  const disabled =
    props.name !== "edit" ? context.disabled.add : context.disabled.edit;
  const isName = props.name !== "add" && props.name !== "edit";
  const icon = props.name === "add" ? <PlusOutlined /> : <EditOutlined />;
  const isSignature = props.url === "/documents/for-signature";
  const isPositions = props.url === "/directories/positions";
  const isEmployeesAndContacts = props.url === "/directories/employees-and-contact-persons";

  const [submitting, setSubmitting] = useState(false);
  const MSG_KEY = "modal-submit";
  const notAllowed = ["/documents/outcoming", "/documents/incoming", "/documents/internal"];
  const isShowModalButtons = notAllowed.includes(props.url ?? "") && props.name === "edit";
// console.log('MODAL PROPS =======', props.name);


  const showModal = async () => {
    setOpenModalFlag(props?.url);

    // console.log("============================================================================================", props?.url)
    // console.log('props nameForButton ', props.nameForButton);
    // console.log('propss props.url ', props.url);
    // console.log('propss location.pathname', location.pathname);
    // console.log('propss props.name', props);
    //     console.log("Click on row in table  get0", props.url);


// Компонент отримання даних винесений з компоненту таблиці перевіряє на props.url
// потім отримує дані та вставляє дані setSessionData для поточного props.url
// Чому подвійна перевірка url? Бо в минулому компоненті був location.pathname і дані при відкритті Редагування-Посада і вибір посади 
// провокував заміну даних в sessionData з Посади на Співробітники та контактні особи! Також додано нові параментри в ModalContext <RecordId, setRecordId>
    if (isEmployeesAndContacts && !isPositions) {
      let recordId = context.RecordId;
      let content;
        // console.log("Click on row in table  get1", props.url);
          content = (
            await request(`${props.url}/getdatatable`, {
              method: "post",
              body: { id: recordId },
              cancelTokenKey: "getdatatable",
            })
          )?.content;
            setSessionData(content?.[0] ?? {});
    }

// Компонент перевірки прав доступу при натисканні на кнопку
    let accessRights = await checkBefore(location.pathname, props.url, props.name);
    if (!accessRights) {
          message.error(intl('you-do-not-have-access-rights'));
          return;
        }

    if (props.name) {
      context.setActiveModal(
        props.name as
          | "add"
          | "edit"
          | "contact-person"
          | "employee"
          | "add-an-action-for-one-performer"
          | "add-an-action-from-a-template"
      );
    }
    if (props?.setIsShowModal) {
        props.setIsShowModal(true);
    } 
    else {
      setIsModalOpen(true);
    }
    // context.setCloseFlag(false);
    // context.dispose(props.children, null, null, true);
  };

  // const handleOk = () => {
  //   context.modal.onOk?.();
  //   context.dispose(null, onFormSubmit, null, false);
  // };
// console.log("props.isEdit",props.url)
// console.log("props.isEdit",props.isEdit)

  const handleClose = () => {
      // console.log("MODAL STATE ========:", form.getFieldsValue());

    setOpenModalFlag(undefined);

    contextDatePicker.setRefreshDatepickerContext(true);
    if (!props?.setIsShowModal) setIsModalOpen(false);
    message.loading({ content: intl('done'), key: MSG_KEY, duration: 2 });
    setSubmitting(false);
  };

  const handleOk = async () => {
      // console.log("MODAL STATE ========:", form.getFieldsValue());

    try {
      console.log("props url modal  ========:", props);

    // if(props.url !== "/directories/employees-and-contact-persons"){
          if (submitting) return;              //  анти-дубль-натиск
          setSubmitting(true);                 //  вмикаємо спіннер на кнопці
          message.loading({ content: intl('wait-please'), key: MSG_KEY, duration: 0 });
    // }



      await form?.validateFields();

      // if (!props?.setIsShowModal) setIsModalOpen(false);
      // if (props?.setIsShowM) props.setIsShowM(false);
      // else setIsModalOpen(false);

      // setIsModalOpen(false);
      // props?.setIsShowM && props.setIsShowM(false);
      // if(props.url !== "/directories/employees-and-contact-persons"){
            props.form?.submit() || form?.submit();
      // }
      // console.log("submit ", props.form || form)

      isSignature && openSignModal(sessionData, location.pathname);

      if (
        contextTableData?.length &&
        props?.url &&
        props.isEdit !== false &&
        props.isEdit !== true &&
        (contextTableData[0] as any).url === props.url
      ) {
        const saveData = contextTableData?.map((item: any) => ({
          ...item,
          selectedRowKeys: null, // Присвоюємо null для кожного елемента
        }));
        setContextTableData(saveData);
      }
      // console.log(
      //   "ModalComponent contextDatePicker state before :",
      //   contextDatePicker.refreshDatepickerContext
      // );
      contextDatePicker.setRefreshDatepickerContext(true);// Компонент для оновлення даних в таблиці після додавання файлів
      context.setRecordId(null); 

      if(location.pathname !== "/directories/employees-and-contact-persons" && props.url === "/directories/employees-and-contact-persons"){
      // console.log("/directories/employees-and-contact-persons  ========:", props);
        message.success({ content: intl('done'), key: MSG_KEY, duration: 2 });

        setOpenModalFlag(undefined);
        if (!props?.setIsShowModal) setIsModalOpen(false);
      }

    setOpenModalFlag(undefined);
    // console.log("COUNTER 111", context)

      // console.log(
      //   "ModalComponent contextDatePicker state after:",
      //   contextDatePicker.refreshDatepickerContext
      // );

      // context.modal.onOk?.();
      // context.dispose(null, null, null, false);
      // context.rowData && props.onOk?.(context.rowData);
      // context.setCloseFlag(true);
      // props.selectFiles && fetchFilesBody();
    } catch (errorInfo) {
      console.log("Failed modal:", errorInfo);
      message.error({ content: intl('error-submiting'), key: MSG_KEY, duration: 3 });
      setSubmitting(false);
    setOpenModalFlag(undefined);
    }
  };

  // const handleCancel = () => {
  //   context.modal.onCancel?.();
  //   context.dispose(null, null, onFormResetFields, false);
  // };

  const handleCancel = () => {
    setOpenModalFlag(undefined);

    // context.modal.onCancel?.();
    // context.dispose(null, null, null, false);
    setSubmitting(false);
    if (
      contextTableData?.length > 0 &&
      props?.url &&
      props.isEdit !== false &&
      props.isEdit !== true &&
      (contextTableData[0] as any).url === props.url
    ) {
      const saveData = contextTableData?.filter(
        (item: any) => !item.selectedRowKeys
      );
      setContextTableData(saveData);
    }

    if (props?.setIsShowModal) props.setIsShowModal(false);
    else setIsModalOpen(false);

    contextDatePicker.setRefreshDatepickerContext(true); 
    closeSignModal();
    // console.log("COUNTER 111", modalCounter)

    // props.form?.resetFields();
  };

  // Колбек, який форма викличе після завершення запиту:
const onSubmitDone = (ok: boolean, errorMessage?: string) => {
  setSubmitting(false); // спінер гасимо в будь-якому випадку

  if (ok) {
    message.success({ content: intl('done'), key: MSG_KEY, duration: 3 });
    if (props?.setIsShowModal) props.setIsShowModal(false);
    else setIsModalOpen(false);
  } else {
    message.error({
      content: errorMessage || intl('error-submiting'),
      key: MSG_KEY,            // перезапише "wait-please"
      duration: 3,
    });
    // Модалка ЗАЛИШАЄТЬСЯ відкритою
  }
};

const child =
  (props.children && typeof props.children === "object" && "props" in (props.children as any))
    ? ( 
        ( 
          React.isValidElement(props.children)
        ) ? React.cloneElement(props.children as any, { onSubmitDone }) : props.children
      )
    : props.children;

  // if (!context.modal.isOpen) {
  //   return null;
  // }
  // console.log("PROPS URL ModalComponent", props);

  return (
    <>
    <Tooltip title={intl(`${props.name ? props.name : "add"}`)}>
      <Button
        className={styles["button"]}
        onClick={showModal}
        disabled={disabled}
        icon={!isName && icon}
      >
        {isName && intl(props.name)}
      </Button>
      </Tooltip>
      <Modal
      width={props.width}
        styles={{
          mask: {
            backgroundColor: "rgba(84, 84, 84, 0.80)",
            backdropFilter: "blur(5px)",
          },
        }}
        // className={
        //   props.url === "/directories/employees-and-contact-persons"
        //     ? styles["modal-employees"]
        //     : props.isEdit
        //     ? styles["modal-edit-documents"]
        //     : styles["modal"]
        // }
        className={styles["modal"]}
        open={
          (props?.setIsShowModal && props.isShowModal) ||
          (!props?.setIsShowModal && isModalOpen) /* context.modal.isOpen */
        }
        okText={ isShowModalButtons ? intl("close"): intl("ok")}
        cancelText={intl("cancel")}
        onOk={ isShowModalButtons ? handleClose : handleOk}
        onCancel={handleCancel}
        cancelButtonProps={{
        style: { display: isShowModalButtons ? "none" : undefined },
        disabled: submitting,
        }}
        destroyOnClose={true}
        confirmLoading={submitting}
        okButtonProps={{ loading: submitting, disabled: submitting }}
        maskClosable={false}
        keyboard={false}
        closable={false}

        // cancelButtonProps={{ disabled: submitting }}
      >
       {child}
      </Modal>
    </>
  );
}
